import { BlokToComponentProps } from '@repo/roche-xx-shared';
import { RocheUIAnimatedWords } from '@rocheglobal/roche-ui';
import React, { FC } from 'react';

type RocheAnimatedWordsProps = BlokToComponentProps<{
  headline: string;
  words: string;
}>;

export const RocheAnimatedWords: FC<RocheAnimatedWordsProps> = ({ blok }) => <RocheUIAnimatedWords {...blok} />;
